import React, { useEffect } from 'react'

import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'

import UpgradeModal from 'pages/shared/UpgradeModal'

type Props = {
  closeCallback: (reloadPage) => void
}

const PaywallAcceptModal = ({ closeCallback }: Props) => {
  useEffect(() => {
    Apptentive.sendEvent('premium_acct_created')

    GA4.sendEvent({
      action: 'Premium Account Created',
      category: 'Premium Settings'
    })
  }, [])

  return (
    <UpgradeModal closeCallback={closeCallback} />
  )
}

export default PaywallAcceptModal
